import lazy from 'utils/lazy';

export const LegalInformation = lazy(() => import('./LegalInformation'));
